import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["entry"]
    static values = { rows: Array }

    add() {
        const count = this.entryTargets.length + 1
        const rowsJson = JSON.stringify(this.rowsValue).replace(/"/g, '&quot;')
        const template = `
          <div data-array-function-target="entry">
            <div class="text-[9px] text-gray-500 mb-1">Function ${count}</div>
            <div data-controller="autocomplete" data-autocomplete-field-value="report_table_spec[function_array][]" data-autocomplete-rows-value="${rowsJson}" class="w-full">
              <div class="focus:outline-none border border-gray-300 px-2 py-1.5 rounded cursor-text text-xs" contenteditable="true"
                   data-autocomplete-target="input" data-value="" data-action="blur->autocomplete#onBlur">
              </div>
              <input type="hidden" name="report_table_spec[function_array][]" value="" data-autocomplete-target="hiddenInput" />
            </div>
          </div>
        `
        this.element.querySelector("button").insertAdjacentHTML("beforebegin", template)
    }
}
